export type WebPushDiagnostic = {
  at: string;
  stage: string;
  notificationId?: string | null;
  tokenFingerprint?: string;
  projectId?: string;
  outcome?: string;
  detail?: string;
  visibility?: DocumentVisibilityState;
  focused?: boolean;
};

const STORAGE_KEY = "mami-vendor-web-push:diagnostics";
const MAX_EVENTS = 100;

export const readWebPushDiagnostics = (): WebPushDiagnostic[] => {
  if (typeof window === "undefined") return [];
  try {
    const entries = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(entries) ? entries : [];
  } catch {
    return [];
  }
};

export const recordWebPushDiagnostic = (
  stage: string,
  details: Omit<Partial<WebPushDiagnostic>, "at" | "stage"> = {},
) => {
  const event: WebPushDiagnostic = { at: new Date().toISOString(), stage, ...details };
  console.info("[vendor-web-push]", event);
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...readWebPushDiagnostics(), event].slice(-MAX_EVENTS)));
  } catch {
    // Console output remains available when browser storage is unavailable.
  }
};

export const fingerprintWebPushToken = async (token: string): Promise<string> => {
  try {
    const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(token));
    return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0"))
      .join("").slice(0, 16);
  } catch {
    return "unavailable";
  }
};
